import React, { useState} from "react"
import FsLightbox from "fslightbox-react"
import templateStyles from "./template.module.scss"
import styled from "styled-components"
import Layout from "../components/CoreComponents/layout"
import DescriptionSection from "../components/ProductComponents/DescriptionSection"
import ProductAdd from "../reduxStuff/app/products/components/ProductAdd"
import { Provider } from 'react-redux'
import store from '../reduxStuff/store'
import TextilesColors from '../components/ProductComponents/TextilesColors'
import Image1 from "../images/textilies/Aston-20182_b3noqk.jpg"
import Image2 from "../images/textilies/Aston-20186_bw2afs.jpg"
import Image3 from "../images/textilies/Aston-20187_ourbqo.jpg"
import Image4 from "../images/textilies/Aston-20191_attjtd.jpg"
import Image5 from "../images/textilies/Aston-20193_bdcdxu.jpg"
import Image6 from "../images/textilies/Aston-20195_qtmg5r.jpg"
import Image7 from "../images/textilies/Aston-20197_otebbj.jpg"
import Image8 from "../images/textilies/Aston-20199_clzjrv.jpg"

const ColorWrapper = styled.div`
    width:80%;
    display:flex;
    flex-wrap:wrap;
    justify-content: center;
    margin: 0 auto;
`
const ColorItem = styled.img`
    width:120px;
    height:120px;
    margin:9px;
`
const ColorName = styled.h2`
text-align:center;
`
const ProductHero = styled.div`
  width: 100%;
  height: 132px;
  background-color: #4b4b4b;
  position: absolute;
  top: 0;
  z-index: -50;
`
const ProductViewWrapper = styled.div`
  display: flex;
  width: 85%;
  flex-wrap: wrap;
  margin: 0 auto;
  padding-top: 150px;
  justify-content: space-evenly;
`
const ProductGallery = styled.div`
  max-width: 550px;
  display: flex;
  flex-wrap: wrap;
  div {
    display: block;
    cursor: pointer;
  }
  > :nth-child(-n + 1) {
    max-width: 500px;
  }
  > :nth-child(n + 2) {
    width: 100px;
  }
`
const ProductDetails = styled.div`
  margin-left: 20px;
`

//////////////////////////////////////end style//////////////////
function productTemplate({
   pageContext: { 
     data,
     dataColor,
    }    
  }) 
  {
  const [toggler, setToggler] = useState(false)
  const [colorT, setColorT] = useState()
  const ImageLightviewUrl = []
  const ImageLightviewTitle = []
  const [priceValue, setPriceValue] = useState(data.price)

let textilesGroup = dataColor.edges

const priceUpdate = (e) =>{
 let price;
 let dos = document.getElementsByClassName('checked')
if(dos[0]){
  dos[0].classList.remove('checked')
}
  
  let targetObj = e.target
  targetObj.classList.add("checked");
 setColorT(e.target.alt)    

 textilesGroup.forEach(element => {    
   if(e.target.alt){
   if(e.target.alt.includes(element.node.groupName)){
      if(!data.fabricDimensions){
        data.fabricDimensions = 1
      }
      price = data.price * element.node.priceMultiplier * data.fabricDimensions
      setPriceValue(price) 
     }} 
   
 })

 
}
    data.photos.map(file => {
    ImageLightviewUrl.push(`${file.file.url}`)
    ImageLightviewTitle.push(`${file.title}`)  

    return null 
  })

 
  return (
    <>
       <Provider store={store}>    
      <ProductHero />
      <Layout>
        <ProductViewWrapper>
          <ProductGallery>
            {data.photos.map(file => {
              return (
                <div  key={file.title} onClick={() => setToggler(!toggler)}>
                  <img src={file.file.url} alt={file.title} width="100%" />
                </div>
              )
            })}
          </ProductGallery>
          <ProductDetails>
            <h1>{data.name}</h1>
            <h4><b>Cena: {priceValue} zł brutto</b></h4> 
            <h4><b>Koszt dostawu: 0 zł</b></h4> 
            <p>Dostępne rozmiary:</p>
              <ul>
                <li><p>{data.sizes[1]}</p></li>
                <li><p>{data.sizes[0]}</p></li>
              </ul>
            <p>Zadzwoń 724482102</p>
            <div className={templateStyles.wrapper__button}></div>     
            
            
       




            {/* <ProductAdd productName={data.name} 
            productPrice={priceValue} 
            productPhoto={data.photos[0].file.url} 
            productSize={data.sizes} 
            productColor={colorT} /> */}
          </ProductDetails>
        </ProductViewWrapper>
                <DescriptionSection description={data} />             
        {/* {textilesGroup.map((group)=>{            
                return <TextilesColors key={group.node.groupName} groupInfo={group.node} setColor={priceUpdate}/>
        })} */}
             <ColorName>Wybierz kolor tkaniny:</ColorName>
              <ColorWrapper>        
                <ColorItem alt="Aston1" src={Image1}/>
                <ColorItem alt="Aston2" src={Image2}/>
                <ColorItem alt="Aston3" src={Image3}/>
                <ColorItem alt="Aston4" src={Image4}/>
                <ColorItem alt="Aston5" src={Image5}/>
                <ColorItem alt="Aston6" src={Image6}/>
                <ColorItem alt="Aston7" src={Image7}/>
                <ColorItem alt="Aston8" src={Image8}/>

              </ColorWrapper>
     
        </Layout>
      <FsLightbox
        toggler={toggler}
        sources={ImageLightviewUrl}
        key={ImageLightviewTitle}
      />
      </Provider>
    </>
  )
}

export default productTemplate
